import { render } from "./rolelist.vue?vue&type=template&id=4a7cbdb4"
import script from "./rolelist.vue?vue&type=script&lang=js"
export * from "./rolelist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__